import { Input, Select } from "antd";
import { TableProps } from "antd/es/table";
import { useEffect } from "react";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import ManageDesignation from "../../../../components/Settings/Designation/ManageDesignation";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetDepartmentsQuery } from "../../../../features/department/departmentApi";
import {
  useGetDesignationsQuery,
  useUpdateDesignationStatusMutation,
} from "../../../../features/designation/designationApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { DesignationData, GetDesignationParams } from "../../../../types";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import {
  addKeyInArray,
  selectArrayOption,
  selectSearchOption,
} from "../../../../utils/utils";
import { SettingStatus } from "../Department/Department";

enum DesignationStatus {
  "Inactive",
  "Active",
}

export default function Designation() {
  const { open, handleClose, handleOpen } = useModal();
  const {
    page,
    limit,
    handlePagination,
    handleLimit,
    keyword,
    handleSearch,
    filter,
    handleFilter,
  } = useTable<GetDesignationParams>();
  const {
    isError: isDepartmentError,
    error: departmentError,
    data: departmentData,
  } = useGetDepartmentsQuery({
    params: { skip: 0, limit: 0, is_published: 1 },
  });
  const [
    updateDesignationStatus,
    {
      isSuccess: isStatusUpdateSuccess,
      isError: isStatusUpdateError,
      error: statusUpdateError,
    },
  ] = useUpdateDesignationStatusMutation();
  const { isLoading, isError, error, data } = useGetDesignationsQuery({
    params: {
      ...filter,
      ...(keyword ? { search: keyword } : {}),
    },
  });
  useError(isError, error, "Get designation fail");
  useError(isDepartmentError, departmentError, "Get department data fail");
  useError(
    isStatusUpdateError,
    statusUpdateError,
    "Designation status update fail"
  );

  const columns: TableProps<DesignationData>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Designation Name",
      dataIndex: "name",
    },
    {
      title: "Department Name",
      dataIndex: "department",
      render: (val) => val?.name || "n/a",
    },
    {
      title: "Total Employees",
      dataIndex: "employee_count",
      render: (val) => val ?? 0,
    },
    {
      title: "Status",
      dataIndex: "is_published",
      render: (val) => (
        <div className="flex items-center gap-2">
          <span className={SettingStatus[val ? "active" : "inactive"]}>
            {capitalize(val ? "active" : "inactive")}
          </span>
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   width: 200,
    //   render: (val) => (
    //     <Space size={8}>
    //       <Button
    //         className="action-button"
    //         size="small"
    //         icon={<EditIcon />}
    //         onClick={() =>
    //           handleOpen({
    //             type: "UPDATE",
    //             data: val?.id,
    //           })
    //         }
    //       />
    //       <Space size={4}>
    //         <Switch
    //           checked={val?.is_published === 1}
    //           onChange={() =>
    //             updateDesignationStatus({
    //               id: val?.id,
    //               body: {
    //                 is_published: val?.is_published === 0 ? 1 : 0,
    //               },
    //             })
    //           }
    //           // disabled={isStatusUpdateLoading}
    //           className="custom-switch"
    //         />
    //         <span className="text-header text-sm font-medium">
    //           {DesignationStatus[val?.is_published]}
    //         </span>
    //       </Space>
    //       {/* <span className="text-display-dark">
    //         <InfoIcon />
    //       </span> */}
    //     </Space>
    //   ),
    // },
  ];

  // success toast message
  useEffect(() => {
    if (isStatusUpdateSuccess) {
      toast("success", "Designation status updated successfully");
    }
  }, [isStatusUpdateSuccess]);

  return (
    <SidebarLayout title="Designation List">
      <CustomTable
        loading={isLoading}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data?.totalLength}
        dataSource={addKeyInArray(data?.data?.roles)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by designation name"
              onChange={handleSearch}
            />
            <Select
              allowClear
              showSearch
              placeholder="Department"
              filterOption={selectSearchOption}
              options={selectArrayOption(
                departmentData?.data?.departments || [],
                "name",
                "id"
              )}
              className="min-w-[130px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
              onChange={(val) => {
                handleFilter("business_department_id", val);
              }}
              popupMatchSelectWidth={200}
            />
            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={statusList}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
              value={filter.is_published}
              onChange={(val) => handleFilter("is_published", val)}
            />
            {/* <Button
              icon={<AddIcon />}
              type="primary"
              className="sm-button"
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add Designation
            </Button> */}
          </>
        }
      />

      {(open.type === "ADD" || open.type === "UPDATE") && (
        <ManageDesignation
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}

const statusList = [
  {
    label: "Active",
    value: 1,
  },
  {
    label: "Inactive",
    value: 0,
  },
];
